import Joi from 'joi';

export const analyticsQuerySchema = Joi.object({
  from: Joi.string().isoDate().required(),
  to: Joi.string().isoDate().required(),
  granularity: Joi.string().valid('day').default('day'),
});

export const getOverview = {
  query: Joi.object({
    from: Joi.string().isoDate().required(),
    to: Joi.string().isoDate().required(),
  }),
};

export const getPlatformTimeseries = {
  query: Joi.object({
    from: Joi.string().isoDate().required(),
    to: Joi.string().isoDate().required(),
    granularity: Joi.string().valid('day').default('day'),
  }),
};
